// Dynamic import to prevent Firebase SDK errors in unsupported browsers
let firebaseApp: any = null;
let messaging: any = null;

const firebaseConfig = {
  apiKey: "AIzaSyBXhummYx5wI_bOMgVkSft1lckm5lp5EG4",
  authDomain: "townhealth-467406.firebaseapp.com",
  projectId: "townhealth-467406",
  storageBucket: "townhealth-467406.firebasestorage.app",
  messagingSenderId: "473884235504",
  appId: "1:473884235504:web:70afbea71c513219cad435",
  measurementId: "G-8DL5XJTL3B"
};

// VAPID key for web push notifications
const VAPID_KEY = 'BGlIRtFp-NcX8hvL2yJ0EViitLuqMCKjaqSZQVKxzPcYF-HnbPjXfXvql3YyHGvzTgta8vUtZ1EaJFpCnDDjEH8';

// Initialize Firebase with error handling
async function initializeFirebase() {
  if (firebaseApp && messaging) {
    return { app: firebaseApp, messaging };
  }

  try {
    // Check if we're in a browser environment
    if (typeof window === 'undefined') {
      console.warn('Firebase: Not in browser environment');
      return { app: null, messaging: null };
    }

    // Check if required APIs are available
    if (!('Notification' in window) || !('serviceWorker' in navigator)) {
      console.warn('Firebase: Required APIs not available');
      return { app: null, messaging: null };
    }

    // Dynamic import to prevent errors
    const { initializeApp } = await import('firebase/app');
    const { getMessaging, getToken, onMessage } = await import('firebase/messaging');

    if (typeof initializeApp === 'function' && typeof getMessaging === 'function') {
      firebaseApp = initializeApp(firebaseConfig);
      messaging = getMessaging(firebaseApp);
      console.log('Firebase initialized successfully');
      return { app: firebaseApp, messaging };
    } else {
      console.warn('Firebase SDK not available or not supported in this browser');
      return { app: null, messaging: null };
    }
  } catch (error) {
    console.warn('Firebase initialization failed:', error);
    return { app: null, messaging: null };
  }
}

export async function requestNotificationPermission(): Promise<string | null> {
  try {
    const { messaging } = await initializeFirebase();
    
    if (!messaging) {
      console.warn('Firebase messaging not available');
      return null;
    }

    // Check if notifications are supported
    if (!('Notification' in window)) {
      console.warn('This browser does not support notifications');
      return null;
    }

    const { getToken } = await import('firebase/messaging');
    
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const token = await getToken(messaging, { vapidKey: VAPID_KEY });
      console.log('FCM Token:', token);
      return token;
    } else {
      console.log('Notification permission denied');
      return null;
    }
  } catch (error) {
    console.error('Error getting notification permission:', error);
    return null;
  }
}

export function onMessageListener(): Promise<any> {
  return new Promise(async (resolve) => {
    try {
      const { messaging } = await initializeFirebase();
      
      if (!messaging) {
        console.warn('Firebase messaging not available');
        resolve(null);
        return;
      }

      const { onMessage } = await import('firebase/messaging');
      
      onMessage(messaging, (payload) => {
        console.log('Message received:', payload);
        resolve(payload);
      });
    } catch (error) {
      console.error('Error setting up message listener:', error);
      resolve(null);
    }
  });
}

export { messaging };
export default firebaseApp;
